import React from 'react';
import { onChangeNameValue } from 'services/utils';

export default class AbstractSearchForm extends React.Component {

  constructor(props) {
    super(props);
    const item = props.item || {};
    this.state = {
      item,
    };
    this.defaultSearchState = {};
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.setState({
      item: { ...this.defaultSearchState, ...this.props.item },
    });
    this.getSeachData();
  }
  
  componentWillUnmount() {
    this.mounted = false;
  }

  componentDidUpdate(prevProps) {
    if (this.props.item !== prevProps.item) {
      const item = this.props.item || {};
      this.setState({
        item: { ...this.defaultSearchState, ...item },
      });
    }
  }

  getSeachData() {}

  propertyChanged = (e) => {
    const {propName, value} = onChangeNameValue(e);
    this.setState({
      item: {
        ...this.state.item,
        [propName]: value,
      }
    })
  }

  clear = () => {
    this.setState({
      item: { ...this.defaultSearchState },
    })
  }

  onSubmit = (e) => {
    e.preventDefault();
    this.props.onSubmit(this.state.item);
  }

  render() {
    return <h5>Please add render method.</h5>
  }
}
